import { render, staticRenderFns } from "./TaskDetailView.vue?vue&type=template&id=ad365c54&lang=pug&"
import script from "./TaskDetailView.vue?vue&type=script&lang=js&"
export * from "./TaskDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports